import React from "react";
import { Question } from "../../../../Entities/Question";
import { Tag, Typography } from "antd";
import JobApplicationinterviewRoundQuestionAnswer from "./JobApplicationinterviewRoundQuestionAnswer";
import JobApplicationinterviewRoundsMCQOptions from "./JobApplicationinterviewRoundsMCQOptions";

interface JobApplicationinterviewRoundsDetailsQuestionItemProps {
  question: Question;
  questionNo: number;
  isRoundPending: boolean;
}

const JobApplicationinterviewRoundsDetailsQuestionItem: React.FC<
  JobApplicationinterviewRoundsDetailsQuestionItemProps
> = ({ question, questionNo, isRoundPending }) => {
  const evaluationStatus = question?.evaluation_status || "pending";

  const tagColor =
    evaluationStatus === "qualified"
      ? "green"
      : evaluationStatus === "unqualified"
      ? "red"
      : "blue";

  return (
    <div
      className={`job-application-interview-rounds-details-question-item-container ${
        !isRoundPending && `${evaluationStatus}-container`
      }`}
    >
      {question.type.toLocaleLowerCase() === "mcq" && (
        <JobApplicationinterviewRoundsMCQOptions
          question={question}
          isRoundCompleted={!isRoundPending}
        />
      )}

      <Typography.Text type="secondary" strong style={{ fontSize: 13 }}>
        Candidate's Answer
      </Typography.Text>

      <div className="job-application-interview-rounds-details-question-item-answer-content">
        {question.type.toLocaleLowerCase() === "mcq" ? (
          <div className="job-application-interview-rounds-question-answer-container">
            <Typography.Text type="secondary" style={{ fontSize: 13 }}>
              {question.responses?.[0]?.description || "No answer provided by the candidate."}
            </Typography.Text>
          </div>
        ) : (
          <JobApplicationinterviewRoundQuestionAnswer
            question={question}
            isRoundPending={isRoundPending}
          />
        )}
      </div>

      <Typography.Text type="secondary" strong style={{ fontSize: 13 }}>
        AI Analysis Insights
      </Typography.Text>

      <div className="job-application-interview-rounds-details-question-item-ai-analysis-content">
        <div className="job-application-profile-match-result-item-ai-response-content">
          <div className="job-application-profile-match-result-item-ai-response-icon-container ai-icon-shine-container">
            <img
              src="/icons/ai-stars.svg"
              alt="ai icon"
              className="ai-icon-shine"
            />
          </div>
          <Typography.Text>
            {(() => {
              // For MCQ questions, show "Correct Answer" or "Incorrect Answer" based on candidate's selection
              if (question.type.toLocaleLowerCase() === "mcq" && !isRoundPending) {
                const correctAnswer = question.options?.find(opt => opt.isCorrectAnswer)?.description;
                const candidateAnswer = question.responses?.[0]?.description;
                
                if (candidateAnswer && correctAnswer) {
                  return candidateAnswer === correctAnswer ? "Correct Answer" : "Incorrect Answer";
                }
                return "No answer provided by the candidate.";
              }
              
              // For other question types, show evaluation_reason if available
              if (!isRoundPending && question.evaluation_reason) {
                return question.evaluation_reason;
              }
              
              // Default waiting message
              return "Waiting for candidate's answer and round completion.";
            })()}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default JobApplicationinterviewRoundsDetailsQuestionItem;
